import React from 'react';
import { insertLink } from '../../../markup/commands';
import { ToolbarLink } from '../custom/ToolbarLink';
export const MToolbarLink = ({ focus, onClick, editor, className }) => {
    const selection = editor.cm.getSelection();
    return (React.createElement(ToolbarLink, { focus: focus, onClick: onClick, className: className, active: false, enable: true, formInitialText: selection, formReadOnlyText: Boolean(selection), onSubmit: (url, text) => {
            insertLink({ url, text })(editor.cm);
        }, removeLink: () => {
            throw new Error('Function not implemented.');
        } }));
};
